export const CalculateDateDifferenceAsString = (startDate: Date, endDate: Date): string => {
  const firstDateInMs = startDate.getTime();
  const secondDateInMs = endDate.getTime();

  let totalDifferenceInMs = Math.abs(secondDateInMs - firstDateInMs);

  const aDayInMs = 24 * 60 * 60 * 1000;
  const anHourInMs = 60 * 60 * 1000;
  const aMinuteInMs = 60 * 1000;
  const aSecondInMs = 1000;

  const days = Math.floor(totalDifferenceInMs / aDayInMs);

  if (days !== 0) {
    return `${days} day${days > 1 ? 's' : ''}`;
  } else {
    totalDifferenceInMs %= aDayInMs;

    const hours = Math.floor(totalDifferenceInMs / anHourInMs);
    totalDifferenceInMs %= anHourInMs; // Remaining time after hours

    const minutes = Math.floor(totalDifferenceInMs / aMinuteInMs);
    totalDifferenceInMs %= aMinuteInMs; // Remaining time after minutes

    const seconds = Math.round(totalDifferenceInMs / aSecondInMs);

    if (hours !== 0) {
      let result = `${hours} hour${hours > 1 ? 's' : ''}`;
      if (minutes > 0) {
        result += ` ${minutes} minute${minutes > 1 ? 's' : ''}`;
      }
      return result;
    } else if (minutes !== 0) {
      let result = `${minutes} minute${minutes > 1 ? 's' : ''}`;
      if (seconds > 0) {
        result += ` ${seconds} second${seconds > 1 ? 's' : ''}`;
      }
      return result;
    } else if (seconds !== 0) {
      return `${seconds} second${seconds > 1 ? 's' : ''}`;
    } else {
      return 'less than a second';
    }
  }
};
